import { render, staticRenderFns } from "./menu-estatistica.vue?vue&type=template&id=2fd627da&"
import script from "./menu-estatistica.vue?vue&type=script&lang=js&"
export * from "./menu-estatistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports